import { LanguageCodes } from 'global/constants';
import { BaseSectionOverview } from 'approot/activity-builder/activity-builder.constants';
import { ActivityBuilderThemeContextProvider } from 'approot/activity-builder/theme/activity-builder-theme';
import type { GetActivitiesSectionsQuery } from '../../lesson-builder.graphql.generated';
import {
  ActivityPrintMetadata,
  SECTION_PRINT_CONTAINER_CLASS_NAME,
} from './activity-answers-print.constants';
import ActivityAnswerPrintSection from './activity-answers-print-section';
import ActivityAnswersPrintIntro from './activity-answers-print-intro';
import * as Styled from './activity-answers.style';
import type { Pluck } from 'lib/gql/pluck';

type Props = {
  contentFontSize: number;
  metadata: ActivityPrintMetadata;
  sections: (
    | Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections'>
    | Pluck<GetActivitiesSectionsQuery, 'getActivitiesSections.subSections'>
  )[];
  sectionOverviews: BaseSectionOverview[];
  studentId?: number;
  language?: LanguageCodes;
  includesIntro?: boolean;
  onRenderComplete?: (totalPages: number) => void;
  contentVersion: string | null | undefined;
};

const ActivityAnswersPrintGenerator = ({
  contentFontSize,
  metadata,
  sections,
  sectionOverviews,
  studentId,
  language,
  onRenderComplete,
  contentVersion,
  includesIntro = true,
}: Props) => {
  // total pages here is excluding the intro
  const totalPages = sections.length;

  return (
    <ActivityBuilderThemeContextProvider initialFontSize={contentFontSize}>
      <Styled.ActivityAnswersA4>
        {includesIntro && (
          <Styled.ActivityAnswersPage
            className={SECTION_PRINT_CONTAINER_CLASS_NAME}
          >
            <ActivityAnswersPrintIntro {...metadata} />
          </Styled.ActivityAnswersPage>
        )}
        {sections.map((section, index) => (
          <Styled.ActivityAnswersPage
            key={section.id}
            className={SECTION_PRINT_CONTAINER_CLASS_NAME}
          >
            <ActivityAnswerPrintSection
              language={language}
              includesIntro={includesIntro}
              index={index}
              section={section}
              unitName={metadata.unitName}
              contentName={metadata.contentName}
              userName={metadata.userName || ''}
              subject={metadata.subjectName}
              sectionsOverview={sectionOverviews}
              studentId={studentId}
              onRenderComplete={() => onRenderComplete?.(totalPages)}
              contentVersion={contentVersion}
            />
          </Styled.ActivityAnswersPage>
        ))}
      </Styled.ActivityAnswersA4>
    </ActivityBuilderThemeContextProvider>
  );
};

export default ActivityAnswersPrintGenerator;
